import axios from "axios";
import { AUTH_TOKEN_URL, AUTH_URL_CALL } from "./constants";
import { urlParams } from "./helpers";
import { promises } from "dns";
import { getEnv } from "../config/runtimeEnv";
export let UserTabs: any = [];
let forbiddenCount =0

const clearCacheStorage = async () => {
    try {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(cache => caches.delete(cache)));

    } catch (error) {
      console.error('Error clearing cache storage:', error);
    }
  };

const getToken = (code: any, code_verifier: any) => {
 
    axios({
        url: AUTH_TOKEN_URL,
        method: 'post',
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/x-www-form-urlencoded",
            "Authorization": "Basic " + getEnv("REACT_APP_AUTH"),//ReactClientId:bae8ef2b-b621-f3b1-00ae-e48a4e49ed19
        },
        timeout: 40000,
        data:
            "grant_type=authorization_code" +
            "&code=" + code +
            "&client_id=" + getEnv("REACT_APP_AUTH_CLIENT_ID") +
            "&client_secret=" + getEnv("REACT_APP_AUTH_SECRET") +
            "&redirect_uri=" + getEnv("REACT_APP_AUTH_REDIRECT_URL") +
            "&code_verifier=" + code_verifier +
            "&scope=" + getEnv("REACT_APP_AUTH_CLIENT_SCOPE")
    }).then((response) => {
        sessionStorage.removeItem("Logout")
            localStorage.removeItem('codeverfier');
            localStorage.setItem("token", response.data.access_token);
           // localStorage.setItem("id_token", response.data.id_token);
            localStorage.setItem("refresh_token", response.data.refresh_token);
            localStorage.setItem("token_expire", response.data.expires_in);
            var exp = Date.now() + (response.data.expires_in * 1000);
            localStorage.setItem("token_expire_date", exp.toString());
            document.cookie = "logedIn=true"
            window.location.href ="/"
            return response
    }).catch((error) => {
            forbiddenCount +=1
            if(forbiddenCount==5){
                clearCacheStorage()
            }
            localStorage.removeItem('codeverfier');
            attempt()
            return Promise.reject(error)
            
    });
}



async function refreshToken() {
    let res = true;
    var expire: any = localStorage.getItem("token_expire_date");

    if (Date.now() >= expire) {
 await   axios({
        url: getEnv("REACT_APP_AUTH_URL")+"/api/Auth/refresh-token",
        method: 'post',
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
            "Authorization": "Basic " + getEnv("REACT_APP_AUTH"),
        },
        timeout: 40000,
        data:{
            refreshToken:localStorage.getItem("refresh_token") 
        }
 

    }).then((response) => {

        localStorage.setItem("refresh_token", response.data.data.refreshToken);
        localStorage.setItem("token", response.data.data.accessToken);
        document.cookie = "logedIn=true"
        // let exp = new Date(response.data.data.expiresAt).getTime()
        // localStorage.setItem("token_expire_date", exp+"");

var exp = Date.now() + (response.data.data.expiresIn * 1000);
            localStorage.setItem("token_expire_date", exp.toString());

    
    }).catch((error) => {


 
        localStorage.setItem("catch-token",JSON.stringify(error) );
        const Idtoken = localStorage.getItem("id_token");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
     //   localStorage.removeItem("id_token");
      //  localStorage.removeItem("token_expire");
        localStorage.removeItem("CurrentApplication");

          if (UserTabs.length == 0) {
            const openedlogoutWindow = window.open(
           window.location.href = `${getEnv("REACT_APP_AUTH_URL")}/Account/Logout?returnUrl=${getEnv("REACT_APP_AUTH_REDIRECT_URL")}/?logout=true`
            );
  
            UserTabs = [...UserTabs, openedlogoutWindow];
          }
  
          UserTabs?.forEach((item) => {
            item?.close();
          });
          UserTabs = [];
  
          window.location.href = "/";
        res = false;
     
    });
   
   }
    return res;
}

function authentication() {
    const pkceChallenge = require("pkce-challenge");
    const challenge = pkceChallenge(43);
    localStorage.setItem('codeverfier', challenge.code_verifier);
    window.location.href = AUTH_URL_CALL + challenge.code_challenge;
    //window.location.href = process.env.REACT_APP_CURRENT_URL +"/"
    
}
function isTokenExpired() {
    var expire: any = localStorage.getItem("token_expire_date");
    if ( Date.now() >= expire) {
      //  localStorage.removeItem("token_expire")
        return true;
    }else{
        document.cookie = "logedIn=true"
        return false;
    }
}
  async function checkTokenExpire() {
    var res = true

    

    if (isTokenExpired()) {

        res =await refreshToken();
    }else{


        document.cookie = "logedIn=true"
    }
    return res
}
function attempt() {
    let res:any = true
    if (localStorage.getItem("token")) {
        // check expiration
        res = checkTokenExpire();
    }
    else {
        if (localStorage.getItem('codeverfier') && urlParams().code != undefined) {
            var verifier_ = localStorage.getItem('codeverfier');
            var code = urlParams().code;
            // setResult(true);
            getToken(code, verifier_);
        }
        else  {
            if(sessionStorage.getItem("Logout")!="true")
                 authentication();
            
        }
    }
     return res
    

}

export const auth = {
    attempt,
    getToken,
    refreshToken,
    checkTokenExpire,
}


